module.exports = __webpack_public_path__ + "img/selected0-min.e3cc9d6a.png";